import { render, staticRenderFns } from "./AllInspections.vue?vue&type=template&id=15e6baca&"
import script from "./AllInspections.vue?vue&type=script&lang=js&"
export * from "./AllInspections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports